import React from "react";

export default function BasicButton({ label, onClick, className = "", style, disabled = false }) {
	const buttonClassName = `table-btn btn-basic ${className} ${disabled ? ' disabled' : ''}`;
    return (
        <button onClick={onClick} className={buttonClassName} style={style} disabled={disabled}>
            {label}
        </button>
    );
}